import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import DatePicker from "react-date-picker";
import Modal from "react-bootstrap/Modal";
import "../App.css";
import Map from "../assets/images/map.png";
import camera2 from "../assets/images/camera2.png";
import AddMore from "../assets/images/add.png";
import Flag from "../assets/images/flag.png";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { FadeLoader } from "react-spinners";
import Logo from "../assets/images/bayin.png";
import {
  getOwnerCategory,
  logoutOwnerInitiate,
  ownerSignup,
  resendOtp,
  sendOtp,
  sendOtpOnEmail,
} from "../redux/actions/authAction";
import S3FileUpload from "react-s3";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import { s3Config } from "../config/s3bucket";
const initialState = {
  imageUploadType: "",
  AddMapModal: false,
  OtpModalshow: false,
  storeName: "",
  city: "",
  description: "",
  address: "",
  email: "",
  // /mobileNumber: "",
  logo: "",
  banner: [],
  storeCategory: "",
  openTime: "",
  closeTime: "",
  closeTimePeriod: "",
  openTimePeriod: "",
  breakStartHourValue: "",
  breakStartMinuteValue: "",
  breakStartTimePeriod: "",
  breakEndHourValue: "",
  breakEndMinuteValue: "",
  breakEndTimePeriod: "",
  overAllDiscount: "",
  minOrderValue: "",
  lat: "",
  long: "",
  otp: null,
  newPassword: "",
  compareNewPassword: "",
  errors: {},
  mapAddress: "",
  checkedMain: "",

  hoursData: [
    {
      time: "00",
      status: false,
    },
    {
      time: "01",
      status: false,
    },
    {
      time: "02",
      status: false,
    },
    {
      time: "03",
      status: false,
    },
    {
      time: "04",
      status: false,
    },
    {
      time: "05",
      status: false,
    },
    {
      time: "06",
      status: false,
    },
    {
      time: "07",
      status: false,
    },
    {
      time: "08",
      status: false,
    },
    {
      time: "09",
      status: false,
    },
    {
      time: "10",
      status: false,
    },
    {
      time: "11",
      status: false,
    },
    {
      time: "12",
      status: false,
    },
  ],
  minutesData: [
    {
      time: "00",
      status: false,
    },
    {
      time: "01",
      status: false,
    },
    {
      time: "02",
      status: false,
    },
    {
      time: "03",
      status: false,
    },
    {
      time: "04",
      status: false,
    },
    {
      time: "05",
      status: false,
    },
    {
      time: "06",
      status: false,
    },
    {
      time: "07",
      status: false,
    },
    {
      time: "08",
      status: false,
    },
    {
      time: "09",
      status: false,
    },
    {
      time: "10",
      status: false,
    },
    {
      time: "11",
      status: false,
    },
    {
      time: "12",
      status: false,
    },
    {
      time: "13",
      status: false,
    },
    {
      time: "14",
      status: false,
    },
    {
      time: "15",
      status: false,
    },
    {
      time: "16",
      status: false,
    },
    {
      time: "17",
      status: false,
    },
    {
      time: "18",
      status: false,
    },
    {
      time: "19",
      status: false,
    },
    {
      time: "20",
      status: false,
    },
    {
      time: "21",
      status: false,
    },
    {
      time: "22",
      status: false,
    },
    {
      time: "23",
      status: false,
    },
    {
      time: "24",
      status: false,
    },
    {
      time: "25",
      status: false,
    },
    {
      time: "26",
      status: false,
    },
    {
      time: "27",
      status: false,
    },
    {
      time: "28",
      status: false,
    },
    {
      time: "29",
      status: false,
    },
    {
      time: "30",
      status: false,
    },
    {
      time: "31",
      status: false,
    },
    {
      time: "32",
      status: false,
    },
    {
      time: "33",
      status: false,
    },
    {
      time: "34",
      status: false,
    },
    {
      time: "35",
      status: false,
    },
    {
      time: "36",
      status: false,
    },
    {
      time: "37",
      status: false,
    },
    {
      time: "38",
      status: false,
    },
    {
      time: "39",
      status: false,
    },
    {
      time: "40",
      status: false,
    },
    {
      time: "41",
      status: false,
    },
    {
      time: "42",
      status: false,
    },
    {
      time: "43",
      status: false,
    },
    {
      time: "44",
      status: false,
    },
    {
      time: "45",
      status: false,
    },
    {
      time: "46",
      status: false,
    },
    {
      time: "47",
      status: false,
    },
    {
      time: "48",
      status: false,
    },
    {
      time: "49",
      status: false,
    },
    {
      time: "50",
      status: false,
    },
    {
      time: "51",
      status: false,
    },
    {
      time: "52",
      status: false,
    },
    {
      time: "53",
      status: false,
    },
    {
      time: "54",
      status: false,
    },
    {
      time: "55",
      status: false,
    },
    {
      time: "56",
      status: false,
    },
    {
      time: "57",
      status: false,
    },
    {
      time: "58",
      status: false,
    },
    {
      time: "59",
      status: false,
    },
    {
      time: "60",
      status: false,
    },
  ],
  TimeZone: [
    {
      time: "AM",
      status: false,
    },
    {
      time: "PM",
      status: false,
    },
  ],
  hourValue: "",
  minuteValue: "",
  timeValue: "",
  closeMinuteValue: "",
  closeHourValue: "",
};

const center = {
  lat: 28.6259,
  lng: 77.3774,
};

const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [position, setPosition] = useState(null);
  const [iState, updateState] = useState(initialState);
  const [switchFlag, setSwitchFlag] = useState(true);
  const {
    closeHourValue,
    closeMinuteValue,
    minuteValue,
    hoursData,
    TimeZone,
    hourValue,
    minutesData,
    checkedMain,
    closeTimePeriod,
    openTimePeriod,
    breakStartHourValue,
    breakStartMinuteValue,
    breakStartTimePeriod,
    breakEndHourValue,
    breakEndMinuteValue,
    breakEndTimePeriod,
    compareNewPassword,
    newPassword,
    otp,
    storeName,
    mapAddress,
    description,
    address,
    email,
    logo,
    banner,
    storeCategory,
    imageUploadType,
    AddMapModal,
    openTime,
    closeTime,
    overAllDiscount,
    minOrderValue,
    errors,
  } = iState;
  const { categoryList } = useSelector((state) => state.auth);
  let openTimeData1 = [];
  let closeTimeData1 = [];
  let breakStartData1 = [];
  let breakEndData1 = [];
  openTimeData1.push(`${hourValue}:${minuteValue}`);
  closeTimeData1.push(`${closeHourValue}:${closeMinuteValue}`);
  breakStartData1.push(`${breakStartHourValue}:${breakStartMinuteValue}`);
  breakEndData1.push(`${breakEndHourValue}:${breakEndMinuteValue}`);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [dineDisable, setDineDisable] = useState(true);
  const [serviceType, setServiceType] = useState([]);
  const [mobileNumber, setPhoneNumber] = useState("");

  //   const handleChange = event => {

  //   };

  const handleData = () => {
    setSwitchFlag(!switchFlag);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("targett", e.target.value);

    updateState({
      ...iState,
      [name]: value,
    });
  };

  const handlePasswordChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");

    setPhoneNumber(result);
  };

  useEffect(() => {
    dispatch(getOwnerCategory());
  }, []);

  // const override = {
  //     margin: "250px auto",
  //     radius:2,
  //     height:15,
  //     width:5
  //   };
  const handleCheck = (e) => {
    updateState({ ...iState, checkedMain: e.target.checked });
  };

  const handleInputChange = (e) => {
    let { value, checked } = e.target;
    if (checked) {
      setServiceType([...serviceType, value]);
    } else {
      setServiceType(serviceType.filter((item) => item !== value));
    }
  };

  const handleDropDown = (e) => {
    const ID = e.target.value;
    let nameCat = categoryList.filter((item, index) => item?._id == ID);
    console.log("nameCat?.type", nameCat);
    if (nameCat?.[0]?.type == "Food") {
      setDineDisable(false);
    }
    if (nameCat?.[0]?.type == "") {
      setServiceType(["Pick-Up"]);
      setDineDisable(true);
      setChecked2(false);
    }
    updateState({
      ...iState,
      storeCategory: e.target.value,
    });
  };

  // console.log("dine flag---->", dineDisable);

  const handleAddClose = () => {
    updateState({ ...iState, AddMapModal: false });
  };
  const handleAddShow = () => {
    updateState({ ...iState, AddMapModal: true });
  };

  const { OtpModalshow } = iState;

  const handleClose = () => {
    updateState({ ...iState, OtpModalshow: false, otp: "", errors: {} });
  };
  const handleShow = () => {
    updateState({ ...iState, OtpModalshow: true });
  };

  let handleValidation = () => {
    let error = {};
    let formIsValid = true;
    // console.log("banner", banner);
    if (!email.trim()) {
      error.emailIdError = "*Email id can't be empty";
      error.formIsValid = false;
    } else {
      if (!/^.+?@.+?\..+$/.test(email)) {
        error.emailIdError = "*Email format is not valid";
        error.formIsValid = false;
      }
    }

    if (!mobileNumber) {
      error.mobileNumberError = "*Mobile Number  can't be empty";
      formIsValid = false;
    } else {
      if (!/^[1-9][0-9]{9,16}$/.test(mobileNumber)) {
        error.mobileNumberError = "*Only 9-16 digit No. are  allowed";
        error.formIsValid = false;
      }
      if (isNaN(mobileNumber)) {
        error.mobileNumberError = " * Mobile Number accept numbers only";
        formIsValid = false;
      }
    }

    if (!logo) {
      error.logoError = "*logo  can't be empty";
      formIsValid = false;
    }

    if (!mapAddress) {
      error.addressError = "*Address  can't be empty";
      formIsValid = false;
    }

    if (!storeName) {
      error.storeNameError = "*Store Name can't be empty";
      formIsValid = false;
    }
    if (banner.length <= 0) {
      error.bannerError = "*Banner Images can't be empty";
      error.formIsValid = false;
    }

    if (!openTimeData1.toString()) {
      error.openTimeDataError = "Open Time  Data Can't Be Empty";
      formIsValid = false;
    }
    if (!closeTimeData1.toString()) {
      error.closeTimeDataError = "Close Time  Data Can't Be Empty";
      formIsValid = false;
    }
    if (!openTimePeriod) {
      error.openTimeDataError = "Open Time  Data Can't Be Empty";
      formIsValid = false;
    }

    if (!closeTimePeriod) {
      error.closeTimeDataError = "Close Time  Data Can't Be Empty";
      formIsValid = false;
    }

    if (!storeCategory) {
      error.storeCategoryError = "*store Category can't be empty";
      formIsValid = false;
    }

    if (serviceType.length == 0) {
      error.serviceTypeError = "*Service Type can't be empty";
      formIsValid = false;
    }
    // if (!otp) {
    //     error.otpError = "*OTP can't be empty";
    //     formIsValid = false;
    // }

    if (!description) {
      error.descriptionError = "*Description can't be empty";
      formIsValid = false;
    }

    if (!overAllDiscount) {
      error.overAllDiscountError = "*Overall Discount can't be empty";
      formIsValid = false;
    } else {
      if (overAllDiscount < 0 || overAllDiscount > 100) {
        error.overAllDiscountError =
          "* Discount should be bewtween 0 to 100% only";
        formIsValid = false;
      }
      if (overAllDiscount < 0) {
        error.overAllDiscountError = " * Overall Discount Can't Be Negative";
        formIsValid = false;
      }
    }
    if (!checkedMain) {
      error.checkedMainError = "Please accept the terms and conditions";
      formIsValid = false;
    }

    if (!minOrderValue) {
      error.minOrderValueError = "*Min Order Value can't be empty";
      formIsValid = false;
    } else {
      if (minOrderValue < 0) {
        error.minOrderValueError = " * Min Order Value Can't Be Negative";
        formIsValid = false;
      }
    }
    if (!newPassword) {
      error.newPasswordError = "*Password can't be empty";
      formIsValid = false;
    } else {
      if (newPassword.length < 8) {
        error.newPasswordError =
          "*Password should not be less than 8 characters";
        error.formIsValid = false;
      }
    }
    if (!compareNewPassword.trim()) {
      error.compareNewPasswordError = " *Confirm Password can't be empty";
      formIsValid = false;
    } else {
      if (compareNewPassword.length < 8) {
        error.compareNewPasswordError =
          "*Password should not be less than 8 characters";
        error.formIsValid = false;
      }
      if (
        compareNewPassword &&
        newPassword &&
        compareNewPassword !== newPassword
      ) {
        error.compareNewPasswordError =
          " * Confirm password must be same as new password";
        formIsValid = false;
      }
    }

    if (!checked1 && dineDisable) {
      error.serviceTypeError = "Service Type Can't Be Empty";
      formIsValid = false;
    }

    if (!checked1 && !checked2) {
      error.serviceTypeError = "Service Type Can't Be Empty";
      formIsValid = false;
    }

    updateState({
      ...iState,
      errors: error,
    });
    return formIsValid;
  };

  let handleOptValidation = () => {
    let error = {};
    let formIsValid = true;
    // console.log("banner", banner);

    if (!otp) {
      error.otpError = "*OTP can't be empty";
      formIsValid = false;
    } else {
      if (isNaN(otp)) {
        error.otpError = " *OTP accept numbers only";
        formIsValid = false;
      }
    }

    updateState({
      ...iState,
      errors: error,
    });
    return formIsValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let formIsValid = handleValidation();
    if (formIsValid) {
      // const dataa = { storeName, description, address, email, mobileNumber, logo, banner, storeCategory, openTime, closeTime, overAllDiscount, minOrderValue, lat: "28.6260606", long: "77.3668853" }
      dispatch(sendOtp({ email }))
        .then((res) => {
          if (res.status === 200) {
            // dispatch(ownerSignup(dataa))
            toast.success(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });

            // navigate("/");
            updateState({ ...iState, OtpModalshow: true });
          } else if (res.status === 501) {
            toast.error("Entered OTP is incorrect", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((err) => {
          const message = err?.response?.data
            ? err?.response?.data?.message
            : "Something went wrong.";
          toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  const handleSignup = (e) => {
    e.preventDefault();
    let formIsValid = handleOptValidation();
    if (formIsValid) {
      const dataa = {
        serviceType: serviceType,
        newPassword,
        closeTimePeriod,
        openTimePeriod,
        breakStartTimePeriod,
        breakEndTimePeriod,
        storeName,
        description,
        address: mapAddress,
        email: email.toLowerCase(),
        mobileNumber,
        logo,
        banner,
        storeCategory,
        openTime: openTimeData1.toString(),
        closeTime: closeTimeData1.toString(),
        breakStartTime: breakStartData1.toString(),
        breakEndTime: breakEndData1.toString(),
        overAllDiscount,
        minOrderValue,
        lat: position.lat,
        long: position.lng,
        otp: parseInt(otp),
      };
      // console.log("Final data---->", dataa)
      dispatch(ownerSignup(dataa))
        .then((res) => {
          if (res.status === 200) {
            navigate("/siginup-success");
            toast.success(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            updateState({
              ...iState,
              storeName: "",
              city: "",
              description: "",
              address: "",
              email: "",
              mobileNumber: "",
              logo: "",
              banner: [],
              storeCategory: "",
              serviceType: "",
              openTime: "",
              closeTime: "",
              breakStartTime: "",
              breakEndTime: "",
              overAllDiscount: "",
              minOrderValue: "",
              lat: "",
              long: "",
              otp: null,
              newPassword: "",
              compareNewPassword: "",
              errors: {},
              mapAddress: "",
            });
          } else {
            toast.error(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((err) => {
          const message = err?.response?.data
            ? err?.response?.data?.message
            : "Something went wrong.";
          toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  // const config = ;

  // ****************bucket functions***************

  window.Buffer = window.Buffer || require("buffer").Buffer;

  const onFileHandler = (e, imageType) => {
    // console.log("e.target.files[0]",e.target.files[0])
    // console.log("Imagetye------>", imageType)
    const file = e.target.files[0];
    // console.log("fileee", file);
    if (file) {
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        S3FileUpload.uploadFile(file, s3Config)
          .then((data) => {
            // console.log("dattaa", data);
            updateState({ ...iState, logo: data.location });
          })

          .catch((err) => console.error(err));
      } else {
        toast.error("Only jpeg ,jpg ,png formats are allowed ", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const updatingBanner = (e, item, index) => {
    if (banner.length > 0) {
      let tempBanner = banner;

      for (let x = 0; x <= tempBanner.length; x++) {
        if (index == x) {
          tempBanner.splice(x, 1, item);
        }
      }

      updateState({ ...iState, banner: [...tempBanner] });
    }
    if (banner.length == 0) {
      updateState({ ...iState, banner: [...banner, item] });
    }
  };

  const onBannerHandler = (e, imageType, index) => {
    // console.log("tempBanner before", tempBanner)

    const file = e.target.files[0];

    if (file) {
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        S3FileUpload.uploadFile(file, s3Config)
          .then((data) => {
            updatingBanner(e, data.location, index);
          })

          .catch((err) => console.error(err));
      } else {
        toast.error("Only jpeg ,jpg ,png formats are allowed: ", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  // ****************Map functions***************

  // console.log("Banner--->", banner)
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyD1TKCPOyPCTVb4brhFCB6qNtygBjV7LNQ",
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  // console.log("isLoaded", isLoaded)

  // ****************AutoComplete functions***************

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e) => {
    // Update the keyword of the input element

    setValue(e.target.value);
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      // console.log("Deskcription--->",description)
      setValue(description, false);

      clearSuggestions();
      updateState({ ...iState, mapAddress: description });

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        // console.log("results0--->", results)
        const { lat, lng } = getLatLng(results[0]);
        //   console.log("📍 Coordinates: ", { lat, lng });
        setPosition({ lat, lng });
        //   map?.setCenter(position)
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      // console.log(suggestion)
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  // console.log("serviceType---->", serviceType);
  return (
    <div>
      <div className="SignupArea LoginArea">
        <div className="container">
          <div className="row">
            <div className="col-sm-7">
              <div className="RegisterLeft">
                <h3>
                  Start Your Journey <br />
                  With Us
                </h3>
                <p>
                  Takes less than 10 minutes to fill out <br /> all the
                  information needed to <br /> register your business.{" "}
                </p>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="LoginBox">
                <figure>
                  <img src={Logo} />
                </figure>
                {/* <span className="Language">
                                    <aside>
                                        <img src={Flag} />
                                    </aside>
                                    <select className="form-control">
                                        <option>English</option>
                                        <option>Arabic</option>
                                    </select>
                                </span> */}
                <h3>Create your Account</h3>
                <form onSubmit={handleSubmit}>
                  {switchFlag ? (
                    <div className="YourDetails">
                      <div className="HeadingTop">
                        <span>Your details</span>
                      </div>
                      <div className="mb-3">
                        <div className="UploadCategory">
                          <div className="UploadImagesLeft">
                            {logo ? (
                              <img src={logo} />
                            ) : (
                              <p>
                                <i className="fa fa-upload"></i> Upload Logo
                                Image <br />
                                <span>(Image Size 400px/400px)</span>
                              </p>
                            )}

                            <input
                              type="file"
                              className="form-control "
                              name="logo"
                              onChange={(e) => onFileHandler(e, "logo")}
                              onClick={(e) => e.target.value == null}
                            />
                          </div>
                        </div>
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.logoError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Store Name"
                          name="storeName"
                          value={storeName}
                          onChange={handleChange}
                        />
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.storeNameError}
                        </span>
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Phone Number"
                          name="mobileNumber"
                          value={mobileNumber}
                          onChange={handlePasswordChange}
                        />
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.mobileNumberError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Email Address"
                          name="email"
                          value={email}
                          onChange={handleChange}
                        />
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.emailIdError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Password"
                          name="newPassword"
                          value={newPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.newPasswordError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Confirm Password"
                          name="compareNewPassword"
                          value={compareNewPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.compareNewPasswordError}
                        </span>
                      </div>

                      <div className="form-group" onClick={handleAddShow}>
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Address"
                          name="address"
                          value={mapAddress}
                          onChange={handleChange}
                        ></textarea>
                        <span className="Location">
                          <i
                            className="fa fa-location-arrow"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.addressError}
                        </span>
                      </div>
                      {/* <button >Login</button> */}
                      <button className="Button" onClick={handleData}>
                        Next
                      </button>
                    </div>
                  ) : (
                    <div className="StoreDetails">
                      <div className="HeadingTop">
                        <span>Store details</span>
                      </div>
                      <div className="form-group">
                        <div className="StoreBanners">
                          <ul>
                            <li>
                              <div className="UploadImages">
                                {banner?.[0] ? (
                                  <img src={banner[0]} />
                                ) : (
                                  <>
                                    <span>
                                      {" "}
                                      <img src={camera2} />
                                    </span>
                                    <h6>Add Banner images </h6>
                                  </>
                                )}
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    onBannerHandler(e, "banners", 0)
                                  }
                                  onClick={(e) => e.target.value == null}
                                />
                              </div>
                            </li>
                            <li>
                              <div className="UploadImages">
                                {banner?.[1] ? (
                                  <img src={banner[1]} />
                                ) : (
                                  <>
                                    <span>
                                      {" "}
                                      <img src={camera2} />
                                    </span>
                                    <h6>Add Banner images</h6>
                                  </>
                                )}
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    onBannerHandler(e, "banners", 1)
                                  }
                                  onClick={(e) => e.target.value == null}
                                />
                              </div>
                            </li>
                            <li>
                              <div className="UploadImages">
                                {banner?.[2] ? (
                                  <img src={banner[2]} />
                                ) : (
                                  <>
                                    <span>
                                      {" "}
                                      <img src={camera2} />
                                    </span>
                                    <h6>Add Banner images</h6>
                                  </>
                                )}

                                <input
                                  type="file"
                                  onChange={(e) =>
                                    onBannerHandler(e, "banners", 2)
                                  }
                                  onClick={(e) => e.target.value == null}
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                        <span
                          className="Error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.bannerError}
                        </span>
                      </div>

                      <div className="form-group">
                        <label>Opening time</label>
                        <div className="TimeMain">
                          <div className="HoverBox">
                            <select
                              class="form-control"
                              name="hourValue"
                              value={hourValue}
                              onChange={handleChange}
                              // value={city}
                              // disabled={startDate ?? city}
                              // onChange={handleValue}
                            >
                              <option value="">HH</option>
                              {hoursData.map((ele) => (
                                <option value={ele?.time}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="MinutesBox">
                            {/* <input type="time" class="form-control" name="openTime" value={openTime} onChange={handleChange} /> */}
                            <select
                              class="form-control"
                              name="minuteValue"
                              value={minuteValue}
                              onChange={handleChange}
                              // disabled={startDate ?? city}
                              // onChange={handleValue}
                            >
                              <option value="">MM</option>

                              {minutesData.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="TimeBox">
                            <select
                              class="form-control"
                              name="openTimePeriod"
                              value={openTimePeriod}
                              onChange={handleChange}
                              // disabled={startDate ?? city}
                              // onChange={handleValue}
                            >
                              <option value="">AM/PM</option>
                              {TimeZone.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.openTimeDataError}
                        </span>
                      </div>
                      <div className="form-group">
                        <label>Closing time</label>
                        <div className="TimeMain">
                          <div className="HoverBox">
                            {/* <input type="time" class="form-control" name="closeTime" value={closeTime} onChange={handleChange} /> */}
                            <select
                              class="form-control"
                              name="closeHourValue"
                              value={closeHourValue}
                              onChange={handleChange}
                              // value={city}
                              // disabled={startDate ?? city}
                              // onChange={handleValue}
                            >
                              <option value="">HH</option>

                              {hoursData.map((ele) => (
                                <option value={ele?.time}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="MinutesBox">
                            <select
                              class="form-control"
                              name="closeMinuteValue"
                              value={closeMinuteValue}
                              onChange={handleChange}
                              // disabled={startDate ?? city}
                              // onChange={handleValue}
                            >
                              <option value="">MM</option>

                              {minutesData.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="TimeBox">
                            <select
                              class="form-control"
                              name="closeTimePeriod"
                              value={closeTimePeriod}
                              onChange={handleChange}
                            >
                              <option value="">AM/PM</option>
                              {TimeZone.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.closeTimeDataError}
                        </span>
                      </div>

                      <div className="form-group">
                        <label>Break Start time</label>
                        <div className="TimeMain">
                          <div className="HoverBox">
                            <select
                              class="form-control"
                              name="breakStartHourValue"
                              value={breakStartHourValue}
                              onChange={handleChange}
                            >
                              <option value="">HH</option>
                              {hoursData.map((ele) => (
                                <option value={ele?.time}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="MinutesBox">
                            <select
                              class="form-control"
                              name="breakStartMinuteValue"
                              value={breakStartMinuteValue}
                              onChange={handleChange}
                            >
                              <option value="">MM</option>
                              {minutesData.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="TimeBox">
                            <select
                              class="form-control"
                              name="breakStartTimePeriod"
                              value={breakStartTimePeriod}
                              onChange={handleChange}
                            >
                              <option value="">AM/PM</option>
                              {TimeZone.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Break End time</label>
                        <div className="TimeMain">
                          <div className="HoverBox">
                            <select
                              class="form-control"
                              name="breakEndHourValue"
                              value={breakEndHourValue}
                              onChange={handleChange}
                            >
                              <option value="">HH</option>
                              {hoursData.map((ele) => (
                                <option value={ele?.time}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="MinutesBox">
                            <select
                              class="form-control"
                              name="breakEndMinuteValue"
                              value={breakEndMinuteValue}
                              onChange={handleChange}
                            >
                              <option value="">MM</option>
                              {minutesData.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                          <div className="TimeBox">
                            <select
                              class="form-control"
                              name="breakEndTimePeriod"
                              value={breakEndTimePeriod}
                              onChange={handleChange}
                            >
                              <option value="">AM/PM</option>
                              {TimeZone.map((ele) => (
                                <option value={ele?.name}> {ele?.time}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* ************************Working******************** */}

                      <div className="form-group">
                        <select
                          className="form-control"
                          name="storeCategory"
                          value={storeCategory}
                          onChange={handleDropDown}
                        >
                          <option value="">Select Category</option>
                          {categoryList?.length > 0 &&
                            categoryList?.map((item, i) => {
                              return (
                                <option value={item._id}>
                                  {item.category_name}
                                </option>
                              );
                            })}
                        </select>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.storeCategoryError}
                        </span>
                      </div>

                      <div class="form-group ">
                        <label>Select Service</label>
                        <div className="CheckDiv">
                          <label class="Checkbox">
                            Pick-Up
                            <input
                              type="checkbox"
                              name="Pick-Up"
                              checked={checked1}
                              value={"Pick-Up"}
                              onChange={(e) => {
                                setChecked1(!checked1);
                                handleInputChange(e);
                              }}
                            />
                            <span class="checkmark"></span>
                          </label>

                          {!dineDisable && (
                            <>
                              <label class="Checkbox">
                                Dine-In
                                <input
                                  type="checkbox"
                                  name="DINE-IN"
                                  disabled={dineDisable}
                                  checked={checked2}
                                  value={"Dine-In"}
                                  onChange={(e) => {
                                    setChecked2(!checked2);
                                    handleInputChange(e);
                                  }}
                                />
                                <span class="checkmark"></span>
                              </label>
                            </>
                          )}
                        </div>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.serviceTypeError}
                        </span>
                      </div>

                      <div className="form-group">
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Description"
                          name="description"
                          value={description}
                          onChange={handleChange}
                        ></textarea>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.descriptionError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Overall Discount in % (All Products)"
                          name="overAllDiscount"
                          value={overAllDiscount}
                          onChange={handleChange}
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.overAllDiscountError}
                        </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Min order value $123"
                          name="minOrderValue"
                          value={minOrderValue}
                          onChange={handleChange}
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.minOrderValueError}
                        </span>
                      </div>
                      <button className="Button">Sign Up</button>
                      <p>
                        Already Have an account? <Link to="/">Login</Link>
                      </p>
                      <p className="text-left">
                        <label class="Checkbox">
                          By proceeding you agree to{" "}
                          <Link to="">Terms & conditions</Link> and{" "}
                          <Link to="">Privacy Policy</Link>
                          <input
                            type="checkbox"
                            onChange={handleCheck}
                            checked={checkedMain}
                          />
                          <span class="checkmark"></span>
                        </label>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.checkedMainError}
                        </span>
                      </p>
                      <p>
                        <button className="BackSignup" onClick={handleData}>
                          <i
                            class="fa fa-long-arrow-left"
                            aria-hidden="true"
                          ></i>{" "}
                          Back
                        </button>
                      </p>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal show={AddMapModal} className="ModalBox BigModal">
          <Modal.Body>
            <div className="Category">
              <button className="CloseModal" onClick={handleAddClose}>
                ×
              </button>
              <form onSubmit={handleAddClose}>
                <div className="form-group">
                  <label>Search Address</label>

                  <div ref={ref}>
                    <input
                      className="form-control"
                      value={value}
                      onChange={handleInput}
                      disabled={!ready}
                      placeholder="Search Address..."
                    />
                    {/* We can use the "status" to decide whether we should display the dropdown or not */}
                    {status === "OK" && <ul>{renderSuggestions()}</ul>}
                  </div>
                  {/* *********************MAP ********************** */}

                  {/* <AutoCompleteInput/> */}

                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{
                        width: "100%",
                        height: "400px",
                      }}
                      center={position}
                      zoom={7}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                    >
                      <Marker position={position} />
                    </GoogleMap>
                  )}

                  {/* <div className="MapBox">
                                        <img src={Map} />
                                    </div> */}
                </div>
                <div className="ModalButton">
                  <button className="Button">Save </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={OtpModalshow}
          onHide={handleClose}
          className="ModalBox MidModal"
        >
          <Modal.Body>
            <div className="optModal">
              <button className="CloseModal" onClick={handleClose}>
                ×
              </button>
              <h3>OTP Verification</h3>
              <p>
                Please enter 6 digit OTP Verification code Received on your
                email address.
              </p>

              <div className="form-group">
                <input
                  type="text"
                  placeholder="Enter OTP "
                  className="form-control formControl"
                  name="otp"
                  value={otp}
                  onChange={handleChange}
                />
                <button className="Reset" onClick={handleSubmit}>
                  Resend
                </button>
                <span style={{ color: "red", fontSize: "12px" }}>
                  {errors.otpError}
                </span>
              </div>
              <div className="ModalButton">
                <button className="Button" onClick={handleSignup}>
                  Submit{" "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default SignUp;
